
import {Link} from 'react-router-dom'

const project = ()=> {


    return(
        <div className="project"> 

        <h1>WORK IN PROGRESS!</h1>
        <p>Meanwhile, please take a look at my github! </p>
        <a href='https://github.com/phoenixkhan97'>GitHub</a>

        <div className='portfolio1'></div>

        <div >
                <Link to='/'><button id="side_bar1">Home</button></Link>
                <Link to='/resume'><button id="side_bar2">Resume</button></Link>
                <Link to='/portfolio'><button id="side_bar3">Portfolio</button></Link>
               
            </div>
 
       
        </div>
    )
}

export default project